import { render } from "./MenuHeader.vue?vue&type=template&id=6e32fda2"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"
script.render = render

export default script